// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__igrhG","requiredAsterisk":"Info_requiredAsterisk__P6jdy"};